// useForm.js
import { useState } from "react";

const useForm = (initialValues = {}) => {
  const [values, setValues] = useState(initialValues);

  const handleChange = (name, value) => {
    setValues({
      ...values,
      [name]: value,
    });
  };

  const resetForm = () => {
    setValues(initialValues);
  };

  // los que viene de un servidor por ejemplo
  const setInitialValues = (newValues) => {
    setValues(newValues);
  };

  return {
    values,
    handleChange,
    resetForm,
    setInitialValues,
  };
};

export default useForm;
